
import MenuUploadUnassignedItemCard from "./menu-upload-unassigned-item-card.vue";
import MenuUploadCarouselCard from "./menu-upload-carousel-card.vue";
import MenuUploadKot from "./menu-upload-kot.vue";
import MenuSetKotGroup from "./menu-set-kot-group.vue";
import MenuCreateCategory from "./menu-create-category.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import MenuCreateNewCategoryTile from "./menu-create-new-category-tile.vue";
import CreateEditCategoryDialog from "../dialogs/create-edit-category-dialog.vue";
import MenuUploadMoveToCategoryPopup from "./menu-upload-move-to-category-popup.vue";
export default {
  components: {
    MenuUploadUnassignedItemCard,
    MenuUploadCarouselCard,
    MenuCreateCategory,
    MenuUploadKot,
    MenuSetKotGroup,
    MenuCreateNewCategoryTile,
    CreateEditCategoryDialog,
    MenuUploadMoveToCategoryPopup
  },
  computed: {
    ...mapState("menu", [
      "categories",
      "menuUploadCurrentStep",
      "menuUploadDragSelection"
    ]),
    ...mapGetters("restaurant", ["getAllBrands", "hasMultipleBrands"]),

    showCategory() {
      return this.id === "set-category";
    }
  },
  props: {
    step: {
      type: Number,
      default: 2
    },
    property: {
      type: String,
      default: ""
    },
    subProperty: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    attributes: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    categories(val) {
      this.updateCategories();
    },
    kotGroups(val) {
      this.updateKotGroups();
    }
  },
  data() {
    return {
      selectedCategory: {},
      categoryBackup: [{}],
      kotGroups: [
        { id: "main-kitchen", label: "Main Kitchen" },
        { id: "juice-counter", label: "Juice Counter" },
        {
          id: "biriyani-counter",
          label: "Biriyani Counter"
        }
      ],
      kotGroupsBackup: [{}],
      activeSlide: 1,
      showCreateCategoryDialog: false
    };
  },
  beforeMount() {
    this.updateKotGroups();
    this.getCategories(true).then((response) => {
      this.updateCategories();
    });
  },
  methods: {
    ...mapActions("menu", ["updateSubCategory", "getCategories"]),
    updateCategories() {
      this.categoryBackup = [...this.categories, {}];
    },
    updateKotGroups() {
      this.kotGroupsBackup = [...this.kotGroups, {}];
    },
    getWidth() {
      const tileCount =
        this.attributes.length + 1 + (this.showCategory ? 1 : 0);
      const minWidth = 260;
      const containerOffset = 120;
      const containerWidth =
        Math.max(
          document.documentElement.clientWidth || 0,
          window.innerWidth || 0
        ) - containerOffset;
      return { width: `${Math.max(containerWidth / tileCount, minWidth)}px` };
    }
  }
};
